import { render, staticRenderFns } from "./MainSideMenu.vue?vue&type=template&id=79728602&scoped=true"
import script from "./MainSideMenu.vue?vue&type=script&lang=js"
export * from "./MainSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79728602",
  null
  
)

export default component.exports